import { FilterList, FilterListItem } from 'react-admin';
import { Loyalty } from '@mui/icons-material';

export const ActionsFilter = () => {
	const parseArrayString = (str: string): string[] => {
		const match = str.match(/\{(.*?)}/);
		if (!match) return [];
		return match[1].split(',').map(s => s.replace(/"/g, '').trim());
	};

	const isSelected = (
		value: Record<string, string>,
		filters: Record<string, string>
	): boolean => {
		const selectedValues = parseArrayString(filters['actions@cs'] || '');
		const currentValue = parseArrayString(value['actions@cs'] || '');

		return currentValue.some(val => selectedValues.includes(val));
	};

	const toggleFilter = (
		value: Record<string, string>,
		filters: Record<string, string>
	) => {
		const raw = filters['actions@cs'] || '';
		const match = raw.match(/\{(.*?)}/);
		const currentValues =
			match?.[1]?.split(',').map(v => v.replace(/"/g, '').trim()) || [];
		const newValueRaw = value['actions@cs'];
		const newValueMatch = newValueRaw.match(/\{(.*?)}/);
		const newValue = newValueMatch?.[1]?.replace(/"/g, '').trim();

		if (!newValue) return filters;

		const isSelected = currentValues.includes(newValue);
		const updatedValues = isSelected
			? currentValues.filter(v => v !== newValue)
			: [...currentValues, newValue];

		return {
			...filters,
			'actions@cs': updatedValues.length
				? `{${updatedValues.map(v => `"${v}"`).join(',')}}`
				: undefined
		};
	};

	return (
		<FilterList label="objects.filters.objectActions" icon={<Loyalty />}>
			<FilterListItem
				label="objects.filters.rent"
				value={{
					'actions@cs': '{"rent"}'
				}}
				isSelected={isSelected}
				toggleFilter={toggleFilter}
			/>
			<FilterListItem
				label="objects.filters.sale"
				value={{
					'actions@cs': '{"sale"}'
				}}
				isSelected={isSelected}
				toggleFilter={toggleFilter}
			/>
		</FilterList>
	);
};
